import styled from "styled-components";
import { Device } from "../../../../components/device";

const PrimaryNavigation = styled.nav`
    display: flex;
    flex-direction: row;
    ${Device.mobileMax} {
        display: none;
    }
    a, button {
        color: var(--app-bar-color, currentColor);
        font-size: 12px;
        letter-spacing: 0.05em;
        font-weight: bold;
        padding-left: 0;
        padding-right: 0;
        padding-top: 20px;
        text-transform: uppercase;
        margin: 0 1rem;
        
        ${Device.laptop} {
            margin-left: 1.5rem;
            margin-right: 1.5rem;
            padding-top: 11px;
        }
    }
`;

export default PrimaryNavigation;